<template>
  <div class="fl-sym-mt-10 fl-sym-p-2">
    <div class="fl-sym-text-xxs fl-sym-text-primary">CREATE PET PROFILE</div>
    <div class="fl-sym-text-5xl fl-sym-font-bold">What’s their breed?</div>
    <div class="fl-sym-text-secondary fl-sym-text-lg fl-sym-mt-2">
      We need baseline information to triage your pet’s symptoms.
    </div>
    <div class="fl-sym-flex fl-sym-justify-between fl-sym-mt-5">
      <div
        class="fl-sym-w-1/5 fl-sym-h-1 fl-sym-bg-primary fl-sym-rounded-full"
      ></div>
      <div
        class="fl-sym-w-1/5 fl-sym-h-1 fl-sym-bg-primary fl-sym-rounded-full"
      ></div>
      <div
        class="fl-sym-w-1/5 fl-sym-h-1 fl-sym-bg-graduate fl-sym-rounded-full"
      ></div>
      <div
        class="fl-sym-w-1/5 fl-sym-h-1 fl-sym-bg-graduate fl-sym-rounded-full"
      ></div>
    </div>
    <form class="fl-sym-mt-10">
      <BreedComponent v-model="pet_data" />

      <button
        class="fl-sym-w-full fl-sym-relative fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-primary fl-sym-text-sm fl-sym-rounded-full fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-3 fl-sym-mt-10 hover:fl-sym-border-primary"
        @click="handleStepTwoDispatch"
      >
        Weight
        <div
          class="fl-sym-absolute fl-sym-inset-y-0 fl-sym-right-0 fl-sym-flex fl-sym-justify-center fl-sym-items-center fl-sym-pr-4 fl-sym-text-2xl"
        >
          <font-awesome-icon icon="chevron-right" />
        </div>
      </button>
    </form>
    <div class="fl-sym-text-center">
      <span
        class="fl-sym-mx-auto fl-sym-font-semibold fl-sym-text-primary fl-sym-text-sm hover:fl-sym-text-opacity-75 fl-sym-cursor-pointer"
        @click="$router.go(-1)"
      >
        Back
      </span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"
import BreedComponent from "@/components/pet/BreedComponent.vue"
export default {
  components: {
    BreedComponent,
  },
  computed: {
    ...mapState({
      pet: (state) => state.pet.pet,
    }),
  },
  data() {
    return {
      options: [
        {
          name: "Male",
        },
        {
          name: "Female",
        },
      ],
      pet_data: {
        breed: null,
        gender: "male",
        neutered: false,
      },
    }
  },
  methods: {
    handleStepTwoDispatch(e) {
      e.preventDefault()
      this.$store.dispatch("pet/create_profile_step_2", this.pet_data)
    },
  },
}
</script>
